import { combineReducers } from "redux";
import Battleboard from "./Battleboard";
import PetExplorer from "./PetExplorer";
export default combineReducers({
  petExplorer: PetExplorer,
  battleboard: Battleboard,
});
